<template>

  <svg
    t="1632727277567"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4536"
    width="64"
    height="64"
  ><path d="M736 124H288L64 512l224 388h448l224-388z" p-id="4537" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeHexagon',
} as DefineComponent
</script>